(function () {
  const BACKEND_ENDPOINT = 'https://smashpops-receiver.onrender.com/smashpops-sync';

  const EMAIL_SELECTOR = 'input[name="email"]';
  const COUPON_SELECTOR = '.spps-code span';

  let winHandled = false;

  function resetState() {
    winHandled = false;
    console.log('[SmashPops] State reset');
  }

  function getEmail() {
    const el = document.querySelector(EMAIL_SELECTOR);
    const value = el ? (el.value || '').trim() : '';
    console.log('[SmashPops] Email read:', value);
    return value;
  }

  function getCoupon() {
    const el = document.querySelector(COUPON_SELECTOR);
    const value = el ? (el.textContent || el.innerText || '').trim() : '';
    console.log('[SmashPops] Coupon read:', value);
    return value;
  }

  function sendToBackend(email, coupon_code) {
    if (!BACKEND_ENDPOINT) {
      console.warn('[SmashPops] No BACKEND_ENDPOINT set');
      return;
    }
    console.log('[SmashPops] Sending to backend:', { email, coupon_code });

    return fetch(BACKEND_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, coupon_code })
    })
      .then(function (resp) {
        console.log('[SmashPops] Backend response status:', resp.status);
        return resp.text().then(function (text) {
          console.log('[SmashPops] Backend response body:', text);
        });
      })
      .catch(function (err) {
        console.error('[SmashPops] Backend error:', err);
      });
  }

  function captureAndSend() {
    if (winHandled) {
      console.log('[SmashPops] Win already handled, skipping');
      return;
    }

    var email = getEmail();
    var coupon = getCoupon();

    if (!email || !coupon) {
      console.warn('[SmashPops] Missing email or coupon, not sending');
      return;
    }

    winHandled = true;
    sendToBackend(email, coupon);
  }

  window.onSmashPopsDisplay = function () {
    console.log('[SmashPops] Popup displayed');
    resetState();
  };

  window.onSmashPopsWin = function () {
    console.log('[SmashPops] Win event received, waiting for spin to finish');
    // Wait long enough for the full spin + win screen (~12–14s)
    setTimeout(captureAndSend, 0);
  };

  window.onSmashPopsCloseAfterWin = function () {
    console.log('[SmashPops] Popup closed after win');
    resetState();
  };
})();